import React from 'react';

const cfg = (typeof window !== 'undefined' && window.CHECKOUT_NEXT) || {};

// Minimal inline brand marks so we stay self-contained (no external assets).
const ICONS = {
  google: (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.89 2.68-6.62z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.85.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z"/>
      <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z"/>
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.89 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"/>
    </svg>
  ),
  facebook: (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#1877F2" d="M18 9a9 9 0 1 0-10.41 8.89v-6.29H5.31V9h2.28V7.02c0-2.25 1.34-3.5 3.4-3.5.98 0 2.01.18 2.01.18v2.22h-1.13c-1.12 0-1.47.69-1.47 1.4V9h2.5l-.4 2.6h-2.1v6.29A9 9 0 0 0 18 9z"/>
    </svg>
  ),
};

// Discreet Google / Facebook login (Nextend). Each anchor carries the Nextend
// data-attributes so, if the plugin's JS is present, it upgrades to a popup;
// otherwise the href starts the OAuth redirect. Renders nothing if no provider
// is configured.
export default function SocialButtons() {
  const social = Array.isArray(cfg.social) ? cfg.social : [];
  if (!social.length) return null;

  // Where Nextend returns AFTER social login. NOT "current" — that would carry
  // ?cn_guest=1 back and re-trigger the gate. Drop cn_guest, keep cn_preview so
  // a token-preview session still has access post-login.
  let returnUrl = window.location.origin + '/checkout-next/';
  try {
    const u = new URL(window.location.href);
    u.searchParams.delete('cn_guest');
    returnUrl = u.toString();
  } catch (e) { /* keep default */ }

  return (
    <div className="cn-social">
      <span className="cn-social__label">Άλλοι τρόποι σύνδεσης</span>
      <div className="cn-social__icons">
      {social.map((p) => (
        <a
          key={p.id}
          className={`cn-social__btn cn-social__btn--${p.id}`}
          href={p.url}
          data-plugin="nsl"
          data-action="connect"
          data-redirect={returnUrl}
          data-provider={p.id}
          title={`Συνέχεια με ${p.label}`}
          aria-label={`Συνέχεια με ${p.label}`}
        >
          <span className="cn-social__icon">{ICONS[p.id] || null}</span>
        </a>
      ))}
      </div>
    </div>
  );
}
